import { apiClient, type Paginated } from '@/core/api';
import type {
  AppNotification,
  NotificationPreference,
  NotificationPreferenceUpdate,
} from './types';

const BASE = '/notifications/';
const PREFS_URL = `${BASE}preferences/`;

export interface NotificationListParams {
  page?: number;
  /** Rows per page (backend default 50). */
  page_size?: number;
  is_read?: boolean;
}

export async function listNotifications(
  params: NotificationListParams = {},
): Promise<Paginated<AppNotification>> {
  const { data } = await apiClient.get<Paginated<AppNotification>>(BASE, { params });
  return data;
}

export async function markNotificationRead(id: number): Promise<AppNotification> {
  const { data } = await apiClient.post<AppNotification>(`${BASE}${id}/mark-read/`);
  return data;
}

export async function markAllNotificationsRead(): Promise<{ marked: number }> {
  const { data } = await apiClient.post<{ marked: number }>(`${BASE}mark-all-read/`);
  return data;
}

/** Wave 11 — current user's channel preferences in the active org. */
export async function getNotificationPreferences(): Promise<NotificationPreference> {
  const { data } = await apiClient.get<NotificationPreference>(PREFS_URL);
  return data;
}

export async function updateNotificationPreferences(
  input: NotificationPreferenceUpdate,
): Promise<NotificationPreference> {
  const { data } = await apiClient.patch<NotificationPreference>(PREFS_URL, input);
  return data;
}
